/** @format */
import { css } from 'styled-components';

import { mobile } from '@toucan/client/global/application';

/**
 * Base styles for the question modal content component
 *
 * */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = () => css`
    h1,
    h2,
    h3,
    h4,
    h5 {
        margin-bottom: 3.6rem;
    }

    ul {
        margin: 0 0 1rem;
        padding: 0;
        list-style: none;
        text-align: left;
        column-count: 2;
        column-gap: var(--layout-spacing-48);
    }

    li {
        margin-bottom: var(--layout-spacing-24);
        font-size: 1.2rem;
        color: var(--colors-text-primary);
        page-break-inside: avoid;
        break-inside: avoid-column;

        p {
            margin: 0;

            strong,
            b {
                font-size: 1.6rem;
                display: block;
                color: var(--colors-text-secondary);
                margin-bottom: var(--layout-spacing-12);
            }
        }
    }

    .modal-button {
        margin-top: 2.6rem;
    }

    .modal-button-container {
        text-align: center;
    }

    .accordion-faq {
        padding-bottom: var(--layout-spacing-16);

        .content {
            padding-top: var(--layout-spacing-12);
        }
    }

    ${mobile(css`
        ul {
            column-count: 1;
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The question modal content component styles
 *
 * */
export const styles = () => css`
    ${baseStyles()}
`;
